import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'user-git-server',
    template: require('./user-git-server.component.html')
})
export class UserGitServerComponent {
    @Input() public gitServer: IUserGitServerCredentials;
    @Output() public onRemoveGitServer = new EventEmitter();
    @Output() public onTestGitServer = new EventEmitter<any>();
    public userGitServer: UserGitServerCredentials;
    public hidePass: boolean = true; //used to hide/show the secret in the UI

}

interface IUserGitServerCredentials {
    userId: number;
    GitRepositoryServerId: number;
    GitRepositoryUser: string;
    GitRepositorySecret: string;
}
export class UserGitServerCredentials implements IUserGitServerCredentials{
    public userId: number;
    public GitRepositoryServerId: number;
    public GitRepositoryUser: string;
    public GitRepositorySecret: string;    

    public constructor(userId: number, serverId: number, userName: string, secret: string) {
        this.userId = userId;
        this.GitRepositoryServerId = serverId;
        this.GitRepositoryUser = userName;
        this.GitRepositorySecret = secret;
      }
  }





// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/usersManagement/users/user-git-server/user-git-server.component.ts